import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';

const Overlay = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'visible' // this prevents 'visible' from being passed to DOM
})(({ visible, sx, theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  backdropFilter: 'blur(5px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  opacity: visible ? 1 : 0,
  visibility: visible ? 'visible' : 'hidden',
  transition: 'opacity 0.3s ease, visibility 0.3s ease',
  ...sx
}));

export default Overlay;

// export default function Overlay({ visible, sx }) {
//   return <OverlayComp visible={visible} sx={sx} />;
// }

// import React from 'react';
// import { createPortal } from 'react-dom';
// import { Box } from '@mui/system';
// import { styled } from '@mui/material/styles';

// // Styled overlay
// const StyledOverlay = styled(Box)(({ theme, sx, visible }) => ({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   width: '100%',
//   height: '100%',
//   backgroundColor: 'rgba(0, 0, 0, 0.2)',
//   backdropFilter: 'blur(5px)',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   zIndex: 10,
//   opacity: visible === true ? 1 : 0,
//   visibility: visible === true ? 'visible' : 'hidden',
//   transition: 'opacity 0.3s ease, visibility 0.3s ease',
//   ...sx
// }));

// // Overlay component with portal
// const Overlay = ({ visible, sx, children }) => {
//   const overlayRoot = document.getElementById('overlay-root'); // Reference to the predefined container

//   if (!overlayRoot) return null; // Safety check if the container is missing

//   return createPortal(
//     <StyledOverlay visible={visible} sx={sx}>
//       {children}
//     </StyledOverlay>,
//     overlayRoot
//   );
// };

// export default Overlay;
